/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


// Product Form JS

(function () {
  document.addEventListener('submit', async function (e) {
    const form = e.target;

    if (!form.classList.contains('ajax-cart-form')) return;
    e.preventDefault();
    const formData = new FormData(form);
    const btn = form.querySelector('button');
    try {
      if (btn) btn.disabled = true;
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      });

      const variant = await addRes.json();
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.dispatchEvent(
        new CustomEvent('theme:cart:change', {
          bubbles: true,
          detail: { cart }
        })
      );

      document.dispatchEvent(
        new CustomEvent('theme:cart:reload', { bubbles: true })
      );

      document.dispatchEvent(
        new CustomEvent('theme:cart:popdown', {
          bubbles: true,
          detail: { variant }
        })
      );

      const drawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (drawer) {
        drawer.dispatchEvent(
          new CustomEvent('theme:drawer:open', { bubbles: true })
        );
      }

    } catch (err) {
      console.error('Cart error:', err);
    } finally {
      if (btn) btn.disabled = false;
    }
  });
})();

// Page: GH Templates

document.addEventListener("DOMContentLoaded", function () {
  function runAt(selector, callback) {
    function check() {
      if (document.querySelector(selector)) {
        callback();
      } else {
        requestAnimationFrame(check);
      }
    }
    requestAnimationFrame(check);
  }

  function globalFunction() {
    const productSection = document.querySelector('.gh_product-section');

    if (productSection) {
      const badgeContainers = document.querySelectorAll('.gh-product_reviews');

      badgeContainers.forEach(badgeContainer => {
        const badge = badgeContainer.querySelector('.stamped-badge');
        const caption = badgeContainer.querySelector('.stamped-badge-caption');

        if (caption && caption.classList.contains('formatted-done')) return;

        if (badge && caption) {
          const rating = badge.getAttribute('data-rating');
          const totalReviews = caption.getAttribute('data-reviews');
          const label = caption.getAttribute('data-label') || 'reviews';
          const additionalNote = badgeContainer.getAttribute('data-additional-note');
          
          if (rating) {
            if (additionalNote && additionalNote.trim() !== "") {
              caption.innerHTML = `${rating}/5 ${additionalNote}`;
            } else if (totalReviews) {
              caption.innerHTML = `${rating} (${totalReviews} ${label})`;
            }
            caption.classList.add('formatted-done');
          }
        }
      });
    }
  }
 
  runAt(".gh-product_reviews .stamped-badge-caption", globalFunction);
});


// Smartrr Subscription Widgets script

const autoSelect = () => {
    const customInput = document.querySelector('[data-smartrr-selling-plan-group-id] input');

    if (!customInput) {
        requestAnimationFrame(autoSelect);
        return;
    }

    requestAnimationFrame(() => {
        customInput.click();
        // customInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoSelect);
} else {
    autoSelect();
}

document.addEventListener('theme:variant:change', function(event) {
  const selectedVariant = event.detail ? event.detail.variant : null;

  if (selectedVariant && window.Smartrr) {
    window.Smartrr.ui?.updateVariant?.(selectedVariant.id);
  }

  requestAnimationFrame(() => {
    const activeSelect = document.querySelector('.smartrr-group-active select');
    const sellingPlanInput = document.querySelector('form.shopify-product-form [name="selling_plan"]');

    if (activeSelect && sellingPlanInput) {
      if (sellingPlanInput.value) {
        activeSelect.value = sellingPlanInput.value;
        // activeSelect.dispatchEvent(new Event('change', { bubbles: true }));

        // console.log('UI Dropdown Value:', document.querySelector('.smartrr-group-active select')?.value);
        // console.log('Form Selling Plan Value:', document.querySelector('form.shopify-product-form [name="selling_plan"]')?.value);
      }
    }
  });
});

// Custom Subscripion Widget 

(function () {
  'use strict';

  //console.log('[subscription-widget] script loaded');

  class SubscriptionWidget extends HTMLElement {
    connectedCallback() {
      const jsonEl = this.querySelector('[data-subscription-widget-json]');
      if (!jsonEl) return;

      this.data = JSON.parse(jsonEl.textContent);
      this.activePlan = this.data.plans[0];

      this.tabs = Array.from(this.querySelectorAll('.pack-tab'));
      this.optionSubscribe = this.querySelector('.option--subscribe');
      this.optionOnetime = this.querySelector('.option--onetime');
      this.radios = Array.from(this.querySelectorAll('input[name="purchase_option"]'));

      this.els = {
        discountPercent: this.querySelector('.js-discount-percent'),
        discountPercentBadge: this.querySelector('.js-discount-percent-badge'),
        subscribePrice: this.querySelector('.js-subscribe-price'),
        comparePrice: this.querySelector('.js-compare-price'),
      };

      this.productForm = document.querySelector('[data-product-form]');

      if (!this.productForm) {
        console.warn(
          '[subscription-widget] No element with [data-product-form] found on the page. ' +
          'Add that attribute to your real product <form> so selling_plan / price can be injected into it.'
        );
      }

      this.sellingPlanInput = this.getOrCreateSellingPlanInput();
      this.submitPriceEl = this.getSubmitPriceEl();

      this.bindTabs();
      this.bindOptions();

      this.renderPlan(this.activePlan);
      this.applyPurchaseOption('subscribe');
    }

    getOrCreateSellingPlanInput() {
      if (!this.productForm) return null;

      let input = this.productForm.querySelector('input[name="selling_plan"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        this.productForm.appendChild(input);
      }
      return input;
    }

    getSubmitPriceEl() {
      if (!this.productForm) return null;

      const submitBtn = this.productForm.querySelector('button[type="submit"]');
      if (!submitBtn) return null;

      return submitBtn.querySelector('[data-smartrr-subscribe-price]');
    }

    updateSubmitPrice() {
      if (!this.submitPriceEl) return;

      const isSubscribeSelected = this.radios.find((r) => r.checked)?.value === 'subscribe';
      this.submitPriceEl.textContent = isSubscribeSelected
        ? this.activePlan.price
        : this.data.onetimePrice;
    }

    bindTabs() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = parseInt(tab.dataset.packIndex, 10);
          const plan = this.data.plans.find((p) => p.index === index);
          if (!plan) return;

          this.tabs.forEach((t) => {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });

          this.activePlan = plan;
          this.renderPlan(plan);
        });
      });
    }

    renderPlan(plan) {
      this.els.discountPercent.textContent = plan.discountPercent;
      this.els.discountPercentBadge.textContent = plan.discountPercent;
      this.els.subscribePrice.textContent = plan.price;
      this.els.comparePrice.textContent = plan.compareAtPrice;

      const isSubscribeSelected = this.radios.find((r) => r.checked)?.value === 'subscribe';
      if (isSubscribeSelected) this.setSellingPlanValue(plan.id);

      this.updateSubmitPrice();
    }

    bindOptions() {
      this.radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (radio.checked) this.applyPurchaseOption(radio.value);
        });
      });

      // Clicking anywhere on the label already toggles the radio natively,
      // but we still need the active class on the wrapping <label>.
      [this.optionSubscribe, this.optionOnetime].forEach((optionEl) => {
        optionEl.addEventListener('click', () => {
          const radio = optionEl.querySelector('input[type="radio"]');
          radio.checked = true;
          this.applyPurchaseOption(radio.value);
        });
      });
    }

    applyPurchaseOption(value) {
      const isSubscribe = value === 'subscribe';

      this.optionSubscribe.classList.toggle('is-active', isSubscribe);
      this.optionOnetime.classList.toggle('is-active', !isSubscribe);

      if (isSubscribe) {
        this.setSellingPlanValue(this.activePlan.id);
      } else {
        // Empty + disabled so it's omitted from the form's POST -> Shopify treats it as one-time.
        this.setSellingPlanValue('', true);
      }

      this.updateSubmitPrice();
    }

    setSellingPlanValue(value, disabled) {
      if (!this.sellingPlanInput) return;
      this.sellingPlanInput.value = value;
      this.sellingPlanInput.disabled = Boolean(disabled);
    }
  }

  if (!customElements.get('product-subscription-widget')) {
    customElements.define('product-subscription-widget', SubscriptionWidget);
  }
})();